
/**
 * IsObject
 *
 * @param objValue
 * @returns {boolean}
 * @constructor
 */
export function IsObject( objValue ){

	return objValue && typeof objValue === 'object' && objValue.constructor === Object ;
}

/**
 * Debounce
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {(function(): void)|*}
 * @constructor
 *
 * @source : https://davidwalsh.name/javascript-debounce-function
 */
export function Debounce( func, wait, immediate = false ){

	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}